import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { getRoutes } from "Router/getRoutes";
import { login } from "Thunks";
import {
  selectUser,
  selectNavCommunity,
  selectRouting,
  selectLoggedAs
} from "Selectors";

import ScrollToTop from "Common/ScrollToTop";
import Layout from "Layout/Layout";
import SelectCommunity from "SelectCommunity/SelectCommunity";

export class App extends Component {
  state = {
    loaded: false
  };

  static propTypes = {
    navCommunity: PropTypes.object,
    user: PropTypes.object,
    login: PropTypes.func.isRequired
  };

  componentDidMount(prevProps) {
    this.props.login();
    if (this.props.user === null) {
      $("#app-loader")
        .fadeOut()
        .promise()
        .done(() => $("#app-loader").remove());
    }
    this.unlisten = this.props.history.listen((location, action) => {
      const menuLogo = document.getElementsByClassName("menu__logo").item(0)
        .classList;
      const options = document.getElementsByClassName("setting-options").item(0)
        .classList;

      menuLogo.remove("display-settings");
      options.remove("show");
    });
  }

  componentWillUnmount() {
    this.unlisten();
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.user && this.props.user) {
      this.setState({ loaded: true });
    }

    if (!prevState.loaded && this.state.loaded) {
      $("#app-loader")
        .fadeOut()
        .promise()
        .done(() => $("#app-loader").remove());
    }
  }

  render() {
    const { navCommunity, routing, loggedAs } = this.props;

    if (loggedAs === "EMPTY") {
      return null;
    }

    if (loggedAs === "MEMBER" && !navCommunity) {
      return <SelectCommunity />;
    }

    return (
      <ScrollToTop location={routing.location}>
        <Layout>{getRoutes()}</Layout>
      </ScrollToTop>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  navCommunity: selectNavCommunity(state),
  user: selectUser(state),
  loggedAs: selectLoggedAs(state),
  routing: selectRouting(state)
});

const mapDispatchToProps = dispatch => ({
  login: () => dispatch(login())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/components/App.js